<template>
<div class="re-linking">
  <div class="container">
    <div class="re-linking-main">
      <div class="re-linking-main__scroll-wrapper">
        <ul class="re-linking-main__inner">
          <li class="re-linking-item">
            <PopularAmounts class="re-linking-item__inner" />
          </li>
          <li class="re-linking-item">
            <PopularPairs class="re-linking-item__inner" />
          </li>
          <li class="re-linking-item">
            <OtherCurrencies class="re-linking-item__inner" />
          </li>
          <li class="re-linking-item">
            <RecentConversions class="re-linking-item__inner recent-conversions" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import OtherCurrencies from '@/components/Calculator/ReLinking/OtherCurrencies.vue';
import PopularAmounts from '@/components/Calculator/ReLinking/PopularAmounts.vue';
import PopularPairs from '@/components/Calculator/ReLinking/PopularPairs.vue';
import RecentConversions from '@/components/Calculator/ReLinking/RecentConversions.vue';

export default {
  name: 'CalculatorReLinkingBlock',
  components: { RecentConversions, OtherCurrencies, PopularPairs, PopularAmounts },
};
</script>
